export default __webpack_public_path__ + "static/media/ISC-PropEx-FormBG-Image.07bb5153.jpg";